import React, {Component} from 'react';
import '../../assets/css/contactus.css';
import data from '../../assets/json/contactus/contactus.json';
import ContactInfo from './ContactInfo.js';

export default class ContactUsDetails extends Component{
	state = {
			data: data.contactus
	};
	componentDidMount = () =>{
		window.scrollTo(0, 0);
  	}
  
	render(){
		let {data} = this.state;
		return (
			<div className="contact-us-details-wrapper">
				{
					data.map((img,i) => (
						<div className="align-center" key={i}>
							<ContactInfo
								photo={img.photo}
								caption={img.caption}
							/>
						</div>
					))
				}
			</div>
		);
	}
}